export default "__VITE_ASSET__D0_S7$_3__"